import { DATE_PLACEHOLDER } from "consts";

const STATE_TZ = {
  // Eastern
  CT: "America/New_York",
  DC: "America/New_York",
  DE: "America/New_York",
  FL: "America/New_York",
  GA: "America/New_York",
  IN: "America/Indiana/Indianapolis",
  KY: "America/New_York",
  ME: "America/New_York",
  MD: "America/New_York",
  MA: "America/New_York",
  MI: "America/Detroit",
  NH: "America/New_York",
  NJ: "America/New_York",
  NY: "America/New_York",
  NC: "America/New_York",
  OH: "America/New_York",
  PA: "America/New_York",
  RI: "America/New_York",
  SC: "America/New_York",
  VT: "America/New_York",
  VA: "America/New_York",
  WV: "America/New_York",

  // Central
  AL: "America/Chicago",
  AR: "America/Chicago",
  IL: "America/Chicago",
  IA: "America/Chicago",
  KS: "America/Chicago",
  LA: "America/Chicago",
  MN: "America/Chicago",
  MO: "America/Chicago",
  MS: "America/Chicago",
  OK: "America/Chicago",
  NE: "America/Chicago",
  ND: "America/Chicago",
  SD: "America/Chicago",
  TN: "America/Chicago",
  TX: "America/Chicago",
  WI: "America/Chicago",

  // Mountain
  AZ: "America/Phoenix",
  CO: "America/Denver",
  ID: "America/Denver",
  MT: "America/Denver",
  NM: "America/Denver",
  UT: "America/Denver",
  WY: "America/Denver",

  // Pacific
  CA: "America/Los_Angeles",
  NV: "America/Los_Angeles",
  OR: "America/Los_Angeles",
  WA: "America/Los_Angeles",
};

type ISODateString = string;
export type StateAbbrev = keyof typeof STATE_TZ;

/**
 * Format an ISOString or UNIX timestamp as a date string localized to a
 * specific state, defaulting to NJ.
 */
export function dateStringForState(
  input: ISODateString | number,
  stateAbbr: StateAbbrev = "NJ",
) {
  const date = new Date(input);
  const timeZone = STATE_TZ[stateAbbr] ?? STATE_TZ["NJ"];
  return new Intl.DateTimeFormat("en-US", {
    timeZone,
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
}

export function formatDate(date: string | Date | undefined | null) {
  let dateVal: number | Date | undefined | null = undefined;
  const ISOpattern = /^\d\d\d\d-\d\d-\d\d/;

  if (date == undefined || date == null) {
    return DATE_PLACEHOLDER;
  }

  // date is a Date object
  if (typeof date == "object" && isValidDateObject(date)) {
    dateVal = date;
  }

  // date is a milliseconds string
  if (typeof Number(date) == "number" && !Number.isNaN(Number(date))) {
    dateVal = Number(date);
  }

  // date is an ISO string OR ISO timestamp
  else if (typeof date == "string" && ISOpattern.test(date)) {
    dateVal = Date.parse(date);
  }

  return new Intl.DateTimeFormat("en-US", {
    timeZone: "UTC",
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(dateVal);
}

export function isValidDateObject(dateVal: any) {
  return (
    Object.prototype.toString.call(dateVal) === "[object Date]" &&
    !isNaN(dateVal.getTime())
  );
}
